import React from "react";
import { useAuth } from "@/context/AuthContext";
import SellerDashboard from "@/pages/SellerDashboard";
import InvestorDashboard from "@/pages/InvestorDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "admin") return <AdminDashboard />;
  if (user.role === "seller") return <SellerDashboard />;
  return <InvestorDashboard />;
}
